import { render, staticRenderFns } from "./addgoods.vue?vue&type=template&id=aa52dfd8&scoped=true&"
import script from "./addgoods.vue?vue&type=script&lang=js&"
export * from "./addgoods.vue?vue&type=script&lang=js&"
import style0 from "./addgoods.vue?vue&type=style&index=0&lang=less&"
import style1 from "./addgoods.vue?vue&type=style&index=1&id=aa52dfd8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa52dfd8",
  null
  
)

component.options.__file = "addgoods.vue"
export default component.exports